import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchDashboardReport, fetchRatingData } from "../../actions/summary";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import moment from "moment";
import AccessPage from "../Shared/accessPage";
import Splinechart from "../common/splinechart";
import Loader from "../Shared/loader";
import IpDiscoveryImg from "../../assets/images/shipment-search--shipping-parcel-shipment-search-find.png";
import passiveImg from "../../assets/images/Dashboard-Horizontal-Pills--Streamline-Core.png";
import activeImg from "../../assets/images/Dashboard-Vertical-Pills-5--Streamline-Core.png";
import subdomainImg from "../../assets/images/Web-Hierarchy--Streamline-Core.png";
import WebTechnologyImg from "../../assets/images/web-browser-content-wysiwyg--web-browser-content-wysiwyg-design-development-website.png";
import vulnerabilityImg from "../../assets/images/Inbox-Lock--Streamline-Core.png";
import blackListImg from "../../assets/images/credit-card-declined.png";
import spfDmarcImg from "../../assets/images/Electrical-Circuit--Streamline-Core.png";
import applicationSecurityImg from "../../assets/images/Application_secutity.png";

var Model = require("./model");

const ASMDashboard = () => {
  const dispatch = useDispatch();
  // const id = JSON.parse(localStorage.getItem("user")).organisationId;
  const [loading, setLoading] = useState(false);
  const [isModal, setModal] = useState('');
  const [graphTime, setGraphTime] = useState('');
  const [riskScoreVA, setRiskScoreVa] = useState("");
  const [riskScoreExpiredSSL, setRiskScoreExpiredSSL] = useState("");
  const [riskScoreVulnerableSSL, setRiskScoreVulnerableSSL] = useState("");
  const [riskScoreDangling, setRiskScoreDangling] = useState("");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  // Move useSelector declarations before useEffect hooks
  let summary = useSelector((state) => state?.summary?.dashboardSummary);
  let summaryLoading = useSelector((state) => state?.summary?.loading);
  let ratingData = useSelector((state) => state?.summary?.ratingData);

  useEffect(() => {
    if (id) {
      fetchDashboardReport(id, "ASM", dispatch);
    } else {
      fetchDashboardReport(id, "ASM", dispatch);
    }
  }, [id]);

  // Add debugging logs
  useEffect(() => {
  }, [summaryLoading, summary, ratingData]);
  
  useEffect(() => {
    if (id) {
      fetchRatingData(id, graphTime, dispatch);
    }
  }, [id, graphTime]);

  const generateReport = () => {
    if (loading) {
      return false;
    }
    setLoading(true);
    let data = {
      id: id,
      asm: 'asm'
    }

    // Make sure your Model.default.generateReport includes { responseType: 'blob' }
    Model.default.generateReport(data)
      .then((response) => {
        setLoading(false);
        if (!response.error) {
          try {
            // Use the response data directly as it should already be a blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${clientName?.replace(/\s+/g, '-') || 'report'}-ASM.docx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (e) {
            // console.error removed
          }
        }
      })
      .catch(error => {
        setLoading(false);
        // console.error removed
      });
  };

  // Transform the data into valid x,y coordinates
  const prepareChartData = () => {
    if (!ratingData?.ratings || !Array.isArray(ratingData.ratings)) return { values: [], dates: [] };

    const validData = ratingData.ratings
      .filter(row => row?.createdAt && row?.attackSurfaceSecurityImpact !== undefined)
      .map(row => ({
        value: Number(row.attackSurfaceSecurityImpact) || 0,
        date: moment(row.createdAt).format("DD-MM-YYYY")
      }));

    return {
      values: validData.map(point => point.value),
      dates: validData.map(point => point.date)
    };
  };

  const chartData = prepareChartData();
  const hasValidChartData = chartData.values.length > 0 && chartData.dates.length > 0;

  // Get total score from rating data
  const totalScore = ratingData?.totalScoreDashboard?.attackSurfaceSecurityImpact || 0;

  // Debug logging

  let passiveVaComplaint = Math.sqrt(summary?.ipVulnerability?.toFixed(2));
  let passiveVaBase = Math.sqrt(summary?.assetsDiscovery);

  let passiveVaValue = parseFloat(
    ((passiveVaComplaint / passiveVaBase) * 100)?.toFixed(2)
  );

  if (!isNaN(passiveVaValue) && riskScoreVA == "") {
    // setRiskScoreValue(riskScoreValue);
    if (passiveVaValue == 0) {
      setRiskScoreVa("A1");
    } else if (passiveVaValue < 20) {
      setRiskScoreVa("A2");
    } else if (passiveVaValue < 35) {
      setRiskScoreVa("B1");
    } else if (passiveVaValue < 55) {
      setRiskScoreVa("B2");
    } else if (passiveVaValue < 75) {
      setRiskScoreVa("C1");
    } else {
      setRiskScoreVa("C2");
    }
  }

  let squareRootOfExpiredSSLComplaint = Math.sqrt(summary?.SSlEXpired)?.toFixed(
    2
  );
  let squareRootOfExpiredSSLBase = Math.sqrt(
    summary?.SSlCertificate?.toFixed(2)
  );

  let expiredSSLValue = parseFloat(
    (
      (squareRootOfExpiredSSLComplaint / squareRootOfExpiredSSLBase) *
      100
    )?.toFixed(2)
  );

  if (!isNaN(expiredSSLValue) && riskScoreExpiredSSL == "") {
    if (expiredSSLValue == 0) {
      setRiskScoreExpiredSSL("A1");
    } else if (expiredSSLValue < 20) {
      setRiskScoreExpiredSSL("A2");
    } else if (expiredSSLValue < 35) {
      setRiskScoreExpiredSSL("B1");
    } else if (expiredSSLValue < 55) {
      setRiskScoreExpiredSSL("B2");
    } else if (expiredSSLValue < 75) {
      setRiskScoreExpiredSSL("C1");
    } else {
      setRiskScoreExpiredSSL("C2");
    }
  }

  // End of generate grade for expired SSL

  // Generate Grade for Vulnerable SSL

  let vulnerableSSLComplaint = Math.sqrt(summary?.SSlVulnerable?.toFixed(2));

  let vulnerableSSLValue = parseFloat(
    ((vulnerableSSLComplaint / squareRootOfExpiredSSLBase) * 100)?.toFixed(2)
  );

  if (!isNaN(vulnerableSSLValue) && riskScoreVulnerableSSL == "") {
    if (vulnerableSSLValue == 0) {
      setRiskScoreVulnerableSSL("A1");
    } else if (vulnerableSSLValue < 20) {
      setRiskScoreVulnerableSSL("A2");
    } else if (vulnerableSSLValue < 35) {
      setRiskScoreVulnerableSSL("B1");
    } else if (vulnerableSSLValue < 55) {
      setRiskScoreVulnerableSSL("B2");
    } else if (vulnerableSSLValue < 75) {
      setRiskScoreVulnerableSSL("C1");
    } else {
      setRiskScoreVulnerableSSL("C2");
    }
  }

  // End of generate grade for Vulnerable SSL

  // Genereate grade for dangling domains

  const dangling = summary?.danglingData?.filter(
    (row) =>
      row?.dnsData?.ip &&
      (row?.techStack?.urls?.[`https://${row?.subDomainName}/`]?.status ==
        404 ||
        row?.techStack?.urls?.[`https://${row?.subDomainName}/`]?.status ==
        0) &&
      row?.subDomainName.indexOf("www") == -1
  );

  let danglingBase = Math.sqrt(summary?.subdomains?.toFixed(2));

  let danglingValue = parseFloat(
    ((dangling?.length / danglingBase) * 100)?.toFixed(2)
  );



  if (!isNaN(danglingValue) && riskScoreDangling == "") {
    if (danglingValue == 0) {
      setRiskScoreDangling("A1");
    } else if (danglingValue < 20) {
      setRiskScoreDangling("A2");
    } else if (danglingValue < 35) {
      setRiskScoreDangling("B1");
    } else if (danglingValue < 55) {
      setRiskScoreDangling("B2");
    } else if (danglingValue < 75) {
      setRiskScoreDangling("C1");
    } else {
      setRiskScoreDangling("C2");
    }
  }

  const getArrow = (val) => {
    if (val > 0) return "fa fa-arrow-up fa-1x arrowRed";
    else return "fa fa-arrow-down fa-1x arrowGreen";
  };
  // End of generate grade for danglong domains

  return (
    <div className="container-fluid">
      <AccessPage></AccessPage>
      {!summaryLoading && !loading && !summary && (
        <div className="text-center">
          <Loader />
        </div>
      )}
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Summary</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home </Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Attack Surface Monitoring Details
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
          <span
              className="btn btn-sm btn-primary mr-1 download-report"
              onClick={() => generateReport()}
            >
              Download Report
            </span>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-9">
          <div className="card">
            <div className="body" style={{ minHeight: "380px" }}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6>ASM Health Tracker</h6>
                    <select 
                      className="form-control" 
                      style={{ width: 'auto', backgroundColor: '#fff', color: 'white', border: '1px solid #444' }}
                      onChange={(e) => {
                        setGraphTime(e.target.value);
                      }}
                    >
                      <option value="">Select Time Period</option>
                      <option value="7days">Last 7 days</option>
                      <option value="1month">Last 30 days</option>
                      <option value="3months">Last 3 months</option>
                      
                    </select>
                  </div>
                  {hasValidChartData && (
                    <Splinechart
                      value={chartData.values}
                      date={chartData.dates}
                      name={`ASM Score: ${totalScore}`}
                      color="#1DBF73"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card">
            <div className="body" style={{ minHeight: "380px" }}>
              <h6 className="welcome-text">Top Issues</h6>
              <div className="list-group">
                {summary?.issueArray?.slice(0, 3)?.map((row) => (
                  <Link
                    to={row?.link}
                    className="list-group-item list-group-item-action list-group-item-newUpdate"
                    style={{ color: "white" }}
                  >
                    {row?.msg}
                  </Link>
                ))}
                {summary?.issueArray?.length > 3 &&
                  (
                    <span className="text-center mt-3"
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex"
                      }}
                    >
                      <a
                        onClick={() => {
                          setModal('Form Wizard modal')
                        }}
                        style={{
                          float: "right",
                          color: "#fff",
                        }}
                        className="btn btn-primary"
                      >
                        <i
                          className="fa fa-file-excel-o"
                          style={{ color: "#fff" }}
                        ></i>{" "}
                        View All
                      </a>
                    </span>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={
                `/asset${vendorId ? '/vendor/' + vendorId : ''}`
              }
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    {/* <i
                      className="fa fa-database"
                      style={{ color: "#08283f" }}
                    ></i> */}
                    <span className="iconBoxDashboard">
                      <img src={IpDiscoveryImg} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {summary?.assetsDiscovery || 0}
                    </h5>
                    <p className="text-muted1">
                      IP Discovery
                    </p>
                  </div>
                </div>
                <div className="card-footer">
                  <span className="text-muted1">
                    {!(summaryLoading || loading) ? (
                      <span className="dashboardFirstHeading">
                        {summary?.ipDiscoveryScanDifference &&
                          summary?.ipDiscoveryScanDifference !== 0 ? (
                          <i
                            className={getArrow(summary?.ipDiscoveryScanDifference)}
                          ></i>
                        ) : (
                          ""
                        )}
                        {Math.abs(summary?.ipDiscoveryScanDifference || 0)} v/s last
                        scan
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>
            </Link>
          </span>
        </div>
        <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={`/known-vulnerabilities${vendorId ? '/vendor/' + vendorId : ''}`}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    {/* <i className="fa fa-bug"></i> */}
                    <span className="iconBoxDashboard">
                      <img src={passiveImg} className="img-fluid" />
                    </span>
                    <div className="text-center">
                      <h5 className="m-t-20 mb-0">
                        {/* {riskScoreVA} */}
                        {summary?.CVEDetails || 0}
                      </h5>
                    </div>
                    <p className="text-muted1">Passive V.A</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.passiveVaScanDifference &&
                            summary?.passiveVaScanDifference !== 0 ? (
                            <i
                              className={getArrow(summary?.passiveVaScanDifference)}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.passiveVaScanDifference || 0)} v/s last
                          scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div>
        {summary?.totalActiveVulnerabilities > 0 && (
          <div className="col-sm-2">
            <span className="card mb-3">
              <Link
                to={`/active-scan/issue${vendorId ? '/vendor/' + vendorId : ''}`}
              >
                <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                  <div className="body">
                    <div className="text-center">
                      <span className="iconBoxDashboard">
                        <img src={activeImg} className="img-fluid" />
                      </span>
                      <div className="text-center">
                        <h5 className="m-t-20 mb-0">
                          {summary?.totalActiveVulnerabilities || 0}
                        </h5>
                      </div>
                      <p className="text-muted1">Active V.A</p>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div>
                      <span className="text-muted1">
                        {!(summaryLoading || loading) ? (
                          <span className="dashboardFirstHeading">
                            {0} v/s last scan
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </span>
          </div>
        )}
        <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={`/subdomains${vendorId ? '/vendor/' + vendorId : ''}`}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    {/* <i
                      className="fa fa-search"
                      style={{ color: "#08283f" }}
                    ></i> */}
                    <span className="iconBoxDashboard">
                      <img src={subdomainImg} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">{summary?.subdomains || 0}</h5>
                    <p className="text-muted1">Subdomains</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.SubDomainsScanDifference &&
                            summary?.SubDomainsScanDifference !== 0 ? (
                            <i
                              className={getArrow(summary?.SubDomainsScanDifference)}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.SubDomainsScanDifference || 0)} v/s last
                          scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div>
        {/* <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={"/danglingdomain"}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    <i className="fa fa-exclamation"></i>
                    <div className="text-center">
                      <h3 className="m-t-20 mb-0">
                        {dangling?.length || 0}
                      </h3>
                      <p className="text-muted1">Dangling Subdomain</p>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.danglinDomainNewAdded &&
                            summary?.danglinDomainNewAdded !== 0 ? (
                            <i
                              className={getArrow(
                                summary?.danglinDomainNewAdded
                              )}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.danglinDomainNewAdded || 0)} v/s
                          last scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div> */}
        {/* <div className="col-sm-2">
          <span className="card mb-3">
            <Link to={"/malware-credentials"}>
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    <i
                      className="fa fa-laptop"
                      style={{ color: "#08283f" }}
                    ></i>
                    <h5 className="m-t-20 mb-0">
                      {summary?.MalwareCredential || 0}
                    </h5>
                    <p className="text-muted1">Malware Infected Machines</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.malwareCredNewAdded &&
                          summary?.malwareCredNewAdded !== 0 ? (
                            <i
                              className={getArrow(summary?.malwareCredNewAdded)}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.malwareCredNewAdded || 0)} v/s last
                          scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div> */}

        <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={`/web-technology${vendorId ? '/vendor/' + vendorId : ''}`}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    {/* <i
                      className="fa fa-window-maximize"
                      style={{ color: "#08283f" }}
                    ></i> */}
                    <span className="iconBoxDashboard">
                      <img src={WebTechnologyImg} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">{summary?.techStack || 0}</h5>
                    <p className="text-muted1">Web Technologies</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.webTechnologiesScanDifference &&
                            summary?.webTechnologiesScanDifference !== 0 ? (
                            <i
                              className={getArrow(summary?.webTechnologiesScanDifference)}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.webTechnologiesScanDifference || 0)} v/s last
                          scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div>
        <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={`/spf-dmarc${vendorId ? '/vendor/' + vendorId : ''}`}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    {/* <i
                      className="fa fa-envelope"
                      style={{ color: "#08283f" }}
                    ></i> */}
                    <span className="iconBoxDashboard">
                    <img src={vulnerabilityImg} className="img-fluid" />
                    </span>
                    <div className="text-center">
                      <h5 className="m-t-20 mb-0">
                        {summary?.spfStatus}
                      </h5>
                    </div>
                    <p className="text-muted1">Email Security</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      <span className="dashboardFirstHeading">
                        Non-Compliant
                      </span>{" "}
                      {/* <span className="dashboardSecondHeading">
                        {summary?.spfValid || 0}/1
                      </span> */}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div>

        {/* <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={`/ssl-certificates${vendorId ? '/vendor/' + vendorId : ''}`}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    <i className="fa fa-certificate"></i>
                    <div className="text-center">
                      <h5 className="m-t-20 mb-0">
                        {riskScoreExpiredSSL} 
                        {(summary?.SSlEXpired || 0)?.toFixed(0)}
                      </h5>
                      <p className="text-muted1">Expired SSL</p>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.expiredSSlNewAdded &&
                          summary?.expiredSSlNewAdded !== 0 ? (
                            <i
                              className={getArrow(summary?.expiredSSlNewAdded)}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.expiredSSlNewAdded || 0)} v/s last
                          scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div> */}
        <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={`/vulnerable-certificates${vendorId ? '/vendor/' + vendorId : ''}`}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    {/* <i className="fa fa-certificate"></i> */}
                    <span className="iconBoxDashboard">
                      
                      <img src={blackListImg} className="img-fluid" />
                    </span>
                    <div className="text-center">
                      <h5 className="mt-3 mb-0">
                        {/* {riskScoreVulnerableSSL}  */}
                        {(summary?.SSlVulnerable || 0)?.toFixed(0)}
                      </h5>
                      <p className="text-muted1 mb-0">Vulnerable <span className="d-block">& Expired SSL</span></p>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.sslVulnerableScanDifference &&
                            summary?.sslVulnerableScanDifference !== 0 ? (
                            <i
                              className={getArrow(
                                summary?.sslVulnerableScanDifference
                              )}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.sslVulnerableScanDifference || 0)} v/s
                          last scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div>

        {/* {!id && (
          <div className="col-sm-2">
            <span className="card mb-3">
              <Link to={"/cloud-bucket"}>
                <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                  <div className="body">
                    <div className="text-center">
                      <i
                        className="fa fa-cloud"
                        style={{ color: "#08283f" }}
                      ></i>
                      <h5 className="m-t-20 mb-0">
                        {summary?.CloudBucket || 0}
                      </h5>
                      <p className="text-muted1">Cloud Storage</p>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div>
                      <span className="text-muted1">
                        {!(summaryLoading || loading) ? (
                          <span className="dashboardFirstHeading">
                            {/* <i className="fa fa-arrow-up fa-1x"
                          style={{ color: "#ff0000",fontSize:"20px" }}></i> 
                            {0} v/s last scan
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </span>
          </div>
        )} */}

        <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={`/ip-blacklist${vendorId ? '/vendor/' + vendorId : ''}`}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    {/* <i
                      className="fa fa-database"
                      style={{ color: "#08283f" }}
                    ></i> */}
                    <span className="iconBoxDashboard">
                      <img src={spfDmarcImg} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {summary?.blackListedIp || 0}
                    </h5>
                    <p className="text-muted1">Blacklisted IPs</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.blackListedIpScanDifference &&
                            summary?.blackListedIpScanDifference !== 0 ? (
                            <i
                              className={getArrow(
                                summary?.blackListedIpScanDifference
                              )}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.blackListedIpScanDifference || 0)} v/s
                          last scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div>
        <div className="col-sm-2">
          <span className="card mb-3">
            <Link
              to={`/application-security${vendorId ? '/vendor/' + vendorId : ''}`}
            >
              <div className="card w_card3 mb-0 Dcards" style={{ cursor: "pointer" }}>
                <div className="body">
                  <div className="text-center">
                    {/* <i
                      className="fa fa-database"
                      style={{ color: "#08283f" }}
                    ></i> */}
                    <span className="iconBoxDashboard">
                      <img src={applicationSecurityImg} className="img-fluid" />
                    </span>
                    <h5 className="m-t-20 mb-0">
                      {summary?.nuclieCount || 0}
                    </h5>
                    <p className="text-muted1">Application Security</p>
                  </div>
                </div>
                <div className="card-footer">
                  <div>
                    <span className="text-muted1">
                      {!(summaryLoading || loading) ? (
                        <span className="dashboardFirstHeading">
                          {summary?.blackListedIpScanDifference &&
                            summary?.blackListedIpScanDifference !== 0 ? (
                            <i
                              className={getArrow(
                                summary?.blackListedIpScanDifference
                              )}
                            ></i>
                          ) : (
                            ""
                          )}
                          {Math.abs(summary?.blackListedIpScanDifference || 0)} v/s
                          last scan
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </span>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Top Issues
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal("")}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div className="card">
                <div className="body">
                  <div className="list-group">
                    {summary?.issueArray?.map((row) => (
                      <Link
                        to={row?.link}
                        className="list-group-item list-group-item-action list-group-item-newUpdate"
                        style={{ color: "white" }}
                      >
                        {row?.msg}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ASMDashboard;
